import { memo } from 'react';
import FileUpload from '@src/utils/file-upload';
import './image.less';

interface ImageProps {
  src: string;
}

const Image = memo(({ src }: ImageProps) => {
  const { width, height } = FileUpload.getImageOriginSizeByUrl(280, src);
  return (
    <div
      key={src}
      className="md-img-wrapper"
      style={{ width, height }}
      onClick={() => FileUpload.openImage(src as string)}
    >
      <img src={src} loading="lazy" decoding="async" />
    </div>
  );
});
export default Image;
